import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DragManager from 'utils/project-definition/drag-manager';

export default class NoteObject extends React.Component {
  constructor(props) {
    super(props);
    this.pressHandler = this.pressHandler.bind(this);
    this.clickHandler = this.clickHandler.bind(this);

    this.clickDragManager = new DragManager();
    const { clickDragManager } = this;
    clickDragManager.setListener('onClick', this.clickHandler);
  }

  pressHandler(evt) {
    const { onPress, note, noteIndex } = this.props;
    if (onPress) {
      onPress(note, noteIndex, this, evt);
    }
    this.clickDragManager.startDrag(evt);
  }

  clickHandler(evt) {
    const { onClick, note, noteIndex } = this.props;
    if (onClick) {
      return onClick(note, noteIndex, this, evt);
    }
    return null;
  }

  render() {
    const pressHandler = this.pressHandler;

    const { note, x, y, style } = this.props;

    const posStyle = {
      left: `${x}px`,
      top: `${y}px`,
    };
    let resultStyle = posStyle;

    if (style) {
      resultStyle = { ...style, ...resultStyle };
    }

    const className = classnames('config-note__indicator', this.props.className);

    return (
      <div data-note-id={note.id} key={note.id} className={className} style={resultStyle}>
        <button onMouseDown={pressHandler} onTouchStart={pressHandler} className="config-note__indicator__button" />
      </div>
    );
  }
}
NoteObject.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,

  note: PropTypes.object,
  noteIndex: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
  onClick: PropTypes.func,
  onPress: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/components/configuration/note-object.jsx